import { all, call } from 'redux-saga/effects'

import plsSignUpFetchSaga from './pls-sign-up-fetch-saga'

function* plsSignUpRootSaga() {
    yield all([call(plsSignUpFetchSaga)])
}

export default plsSignUpRootSaga
